(() => {
  'use strict';

  const mobileQuery = window.matchMedia('(max-width: 43.749rem)');

  function disclosures(root = document) {
    return [...root.querySelectorAll('[data-asif-footer-disclosure]')];
  }

  function syncDisclosure(disclosure) {
    const staysOpen = disclosure.dataset.mobileStatic === 'true';

    if (!mobileQuery.matches || staysOpen) {
      disclosure.open = true;
      return;
    }

    if (disclosure.dataset.userToggled !== 'true') disclosure.open = false;
  }

  function initialize(root = document) {
    disclosures(root).forEach((disclosure) => {
      if (disclosure.dataset.footerReady === 'true') return;

      disclosure.dataset.footerReady = 'true';
      disclosure.addEventListener('toggle', () => {
        if (mobileQuery.matches && disclosure.dataset.syncing !== 'true') {
          disclosure.dataset.userToggled = 'true';
        }
      });
      disclosure.dataset.syncing = 'true';
      syncDisclosure(disclosure);
      requestAnimationFrame(() => delete disclosure.dataset.syncing);
    });
  }

  function syncAll() {
    disclosures().forEach((disclosure) => {
      disclosure.dataset.syncing = 'true';
      if (!mobileQuery.matches) disclosure.dataset.userToggled = 'false';
      syncDisclosure(disclosure);
      requestAnimationFrame(() => delete disclosure.dataset.syncing);
    });
  }

  initialize();
  const footerSections = document.querySelectorAll('.shopify-section--footer, .shopify-section--social-stream');
  const visibleSections = new Set();
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) visibleSections.add(entry.target);
        else visibleSections.delete(entry.target);
      }
      document.documentElement.toggleAttribute('data-asif-footer-visible', visibleSections.size > 0);
    });
    for (const section of footerSections) observer.observe(section);
  }
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest?.('[data-asif-footer-help]');
    const launcher = document.querySelector('[data-hub-open]');
    const panel = document.getElementById('asif-hub-panel');
    if (!trigger || !launcher || !panel || document.getElementById('asif-hub')?.hidden) return;
    event.preventDefault();
    launcher.click();
    panel.addEventListener('close', () => trigger.focus(), {once: true});
  });
  mobileQuery.addEventListener('change', syncAll);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
